
<ngx-spinner
  bdColor="rgba(75, 55, 100, 0.5)"
  size="large"
  color="#fff"
  type="line-scale-pulse-out">
      <span class="chevron left"></span>
      <span class="chevron right"></span>
</ngx-spinner>

<ngx-datatable
  class="material striped datatable"
  [rows]="players"
  [columnMode]="'force'"
  [headerHeight]="40"
  [footerHeight]="20"
  [scrollbarH]="true"
  [scrollbarV]="true"
  [rowHeight]="40"
  [reorderable]="true"
>
  <ngx-datatable-column prop="name" [sortable]="true">
    <ng-template
      let-column="column"
      ngx-datatable-header-template
      let-sort="sortFn"
    >
      <span (click)="sort()">
        Name
      </span>
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      {{ row.name }}
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column prop="email" [sortable]="true">
    <ng-template
      let-column="column"
      ngx-datatable-header-template
      let-sort="sortFn"
    >
      <span (click)="sort()">
        Email
      </span>
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      {{ row.email }}
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column prop="phone" [sortable]="true">
    <ng-template
      let-column="column"
      ngx-datatable-header-template
      let-sort="sortFn"
    >
      <span (click)="sort()">
        Phone
      </span>
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <span>
        {{ row.phone }}
      </span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column prop="rank" [sortable]="true">
    <ng-template
      let-column="column"
      ngx-datatable-header-template
      let-sort="sortFn"
    >
      <span (click)="sort()">
        Rank
      </span>
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <span>
        {{ row.rank }}
      </span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column prop="score" [sortable]="true">
    <ng-template
      let-column="column"
      ngx-datatable-header-template
      let-sort="sortFn"
    >
      <span (click)="sort()">
        Score
      </span>
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <span>{{ row.score }}</span>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-column prop="deviceId" [sortable]="true">
    <ng-template
      let-column="column"
      ngx-datatable-header-template
      let-sort="sortFn"
    >
      <span (click)="sort()">
        Device Id
      </span>
    </ng-template>
    <ng-template let-row="row" ngx-datatable-cell-template>
      <span>{{ row.deviceId }}</span>
    </ng-template>
  </ngx-datatable-column>
</ngx-datatable>

<button (click)="back()" class="btn btn-success" style="margin-top:10px; float:left">Back to Results</button>